import {useEffect} from 'react';
import {useLatest} from 'react-use';

import {NAVLINK_TRACKING} from '../appBarTracking';
import useNavLinkTracking from '../hooks/useNavlinkTracking';

type ProfileHoverTrackerProps = {
  version: string;
};

const ProfileHoverTracker: React.FC<ProfileHoverTrackerProps> = ({version}) => {
  const {trackRumAction} = useNavLinkTracking();
  const trackRumActionRef = useLatest(trackRumAction);

  useEffect(() => {
    trackRumActionRef.current?.({datadogAction: NAVLINK_TRACKING.profile.hovered, version});
  }, [version, trackRumActionRef]);

  return null;
};

export default ProfileHoverTracker;
